var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 70,
    viewBox: "0 0 80 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7017 28.0029C36.8758 28.0029 41.8809 22.9978 41.8809 16.8237C41.8809 10.6496 36.8758 5.64453 30.7017 5.64453C24.5276 5.64453 19.5225 10.6496 19.5225 16.8237C19.5225 22.9978 24.5276 28.0029 30.7017 28.0029Z",
    fill: "#CDA876"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0568 17.5678L62.1094 11.2861V9.26321C62.1094 7.98558 61.0447 6.9209 59.7671 6.9209C58.4895 6.9209 57.4248 7.98558 57.4248 9.26321V43.6526H52.6337L44.6485 34.8157C42.3062 32.2604 39.0057 30.7699 35.5987 30.7699H26.5489C22.5031 30.7699 18.7767 32.7928 16.4344 36.0933L3.44518 55.1512C2.27402 56.8547 2.06109 59.197 3.23224 60.9005C4.29693 62.4975 5.89396 63.1363 7.49099 63.1363C9.08802 63.1363 10.685 62.391 11.6433 61.0069L18.3508 51.2118V64.3553H43.2644V48.1242L46.7779 51.9571C47.7361 53.0218 49.1202 53.6606 50.5043 53.6606H62.5353C65.3034 53.6606 67.5393 51.4248 67.5393 48.6566C67.5393 45.8884 65.3034 43.6526 62.5353 43.6526H62.2159V28.2146L76.1632 21.933C77.015 21.5071 77.5473 20.6553 77.5473 19.8036C77.4408 18.8454 76.9085 17.9936 76.0568 17.5678Z",
    fill: "#CDA876"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame8);
export default __webpack_public_path__ + "static/media/frame_8.13baac7fbf39583bb9ada316e01decc0.svg";
export { ForwardRef as ReactComponent };